import { type DeliveryNoteBody } from '../types';

/**
 * Determines the cargo type of a delivery note.
 * @param assetBody - The body of the delivery note to determine the cargo type of
 * @returns The cargo type of the delivery note
 */
export const getCargoType = (assetBody: DeliveryNoteBody) => {
  const isBulkCargo = false; // TODO: there is no definitive rule for detecting bulk cargo

  if (isBulkCargo) {
    return 'bulk';
  }

  const isConcrete =
    assetBody?.transaction?.logisticsPackage?.[0]?.lineItem?.some((lineItem) =>
      Object.hasOwn(lineItem?.product ?? {}, 'concrete'),
    );

  if (isConcrete) {
    return 'concrete';
  }

  return 'piece';
};
